module.exports = __webpack_public_path__ + "static/img/happyData.6e6be735.png";